import Layout from "@/components/feature/Layout";
import HeroSection from "./components/HeroSection";
import CredibilityStrip from "./components/CredibilityStrip";
import CapabilitiesSection from "./components/CapabilitiesSection";
import ProjectTypesSection from "./components/ProjectTypesSection";
import GovernmentExperienceSection from "./components/GovernmentExperienceSection";
import PastPerformanceSection from "./components/PastPerformanceSection";
import TechnologyExpertiseSection from "./components/TechnologyExpertiseSection";
import WhyPartnerSection from "./components/WhyPartnerSection";
import CTAPanel from "@/components/base/CTAPanel";

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <CredibilityStrip />
      <CapabilitiesSection />
      <ProjectTypesSection />
      <GovernmentExperienceSection />
      <PastPerformanceSection />
      <TechnologyExpertiseSection />
      <WhyPartnerSection />
      <CTAPanel
        title="Ready to Partner?"
        description="Mitaja Corporation is a technology partner for government prime contractors and enterprise organizations seeking specialized technical capabilities."
        secondaryAction={{ label: "Contact Us", href: "/contact" }}
        variant="dark"
      />
    </Layout>
  );
}